module.exports = __webpack_public_path__ + "img/shop-header.11685a33.svg";